import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

const Histogram = ({
  openNewPage,
  dateTimesLive,
  dataArrLive,
  getRandomColor,
  chartChannel,
  selectedTabIndex,
  hour,
  minute,
  oneDayDataTs,
  allChannelGroups,
  channelsGroup
}) => {
  const [chartOptions, setChartOptions] = useState([]);
  const [histogramData, setHistogramData] = useState([]);
  ChartJS.register(ArcElement, Tooltip, Legend);



  useEffect(() => {
    const timeArr =
      dateTimesLive
        ?.map(t => {
          const d = new Date(t);
          return isNaN(d) ? null : d.getTime();
        })
        .filter(Boolean) || [];

    const now = new Date();
    const start = new Date(now);
    start.setHours(now.getHours() - hour);
    start.setMinutes(now.getMinutes() - minute);



    const filteredTimeArr =
      oneDayDataTs?.filter(
        t => t >= start.toISOString() && t <= now.toISOString()
      ) || [];


    const availableChannels = dataArrLive.filter(
      (data, index) => data.data.slice(-1)[0] !== null
    );

    let groupChannels = [];
    if (channelsGroup) {
      allChannelGroups.forEach((group) => {
        if (group.groupName === channelsGroup) {
          groupChannels = group.channels;
        }
      })
    }

    let matchedDatasets = availableChannels;

    if (groupChannels?.length > 0) {
      matchedDatasets =
        groupChannels?.length > 0
          ? groupChannels?.map((label) =>
            availableChannels?.find((dataset) => dataset.label === label)
          )
          : availableChannels;
    }

    if (chartChannel?.length > 0) {

      matchedDatasets =
        chartChannel?.length > 0
          ? chartChannel?.map((label) =>
            availableChannels?.find((dataset) => dataset.label === label)
          )
          : availableChannels;
    }

    const convertedTimeArr = Array.isArray(filteredTimeArr) && filteredTimeArr.length > 0 ? filteredTimeArr.map((label) => new Date(label)) : timeArr.map((label) => new Date(label));



    const convertedTimeArrLength = convertedTimeArr.length
    const filteredMatchData = matchedDatasets.map((dataset) => {
      return {
        ...dataset,
        data: Array.isArray(dataset?.data)
          ? dataset?.data?.slice(-convertedTimeArrLength)
          : []
      }
    })

    const datasets = filteredMatchData.map(ds => {
      const color = getRandomColor();
      return {
        label: ds.label,
        data: ds.data,
        backgroundColor: color,

      };
    });


    const newChartData = {
      labels: filteredTimeArr.length ? filteredTimeArr : timeArr,
      datasets,
    };


    const options = {
      scales: {
        x: {
          type: "time",
        },
        y: {
          beginAtZero: true,
        },
      },
      animation: false,
      plugins: {
        decimation: {
          enabled: true,
          algorithm: "lttb",
          threshold: 200,
        },
        zoom: {
          pan: {
            enabled: true,
            mode: "y",
            modifierKey: "ctrl",
          },
          zoom: {
            wheel: {
              enabled: true,
            },
            pinch: {
              enabled: true,
            },

            mode: "y",
          },
        },
        legend: {
          align: "left", // Set the alignment to 'left'
          labels: {
            boxWidth: 5, // Adjust the width of the legend color box
            font: {
              size: 10, // Set the font size
            },
          },
        },
      },
    };
    setChartOptions(options);
    setHistogramData(newChartData);
  }, [dateTimesLive, selectedTabIndex, chartChannel, oneDayDataTs, openNewPage, hour, minute, channelsGroup]);


  return (
    <div>
      {histogramData && histogramData.labels ? (
        <Bar data={histogramData} options={chartOptions} />
      ) : (
        <p>Loading chart data...</p>
      )}
    </div>
  );
};

const NewHistogram = ({
  dateTimesLive,
  dataArrLive,
  getRandomColor,
  chartChannel,
  selectedTabIndex,
  endHours,
  endMinutes,
  oneDayDataTs,
  channelsGroup,
  allChannelGroups

}) => {
  const [newChartData, setNewChartData] = useState([]);
  const [chartOptions, setChartOptions] = useState([]);

  ChartJS.register(ArcElement, Tooltip, Legend);
  useEffect(() => {
    const timeArr =
      dateTimesLive
        ?.map(t => {
          const d = new Date(t);
          return isNaN(d) ? null : d.getTime();
        })
        .filter(Boolean) || [];

    const now = new Date();
    const start = new Date(now);
    start.setHours(now.getHours() - endHours);
    start.setMinutes(now.getMinutes() - endMinutes);



    const filteredTimeArr =
      oneDayDataTs?.filter(
        t => t >= start.toISOString() && t <= now.toISOString()
      ) || [];


    let channelsLastValues = [];
    let arrData;

    const availableChannels = dataArrLive.filter(
      (data, index) => data.data.slice(-1)[0] !== null
    );

    availableChannels?.forEach((data) =>
      channelsLastValues?.push({
        label: data.label,
        data: data.data,
        backgroundColor: getRandomColor(),
      })
    );

    let groupChannels = [];
    if (channelsGroup) {
      allChannelGroups?.forEach((group) => {
        if (group.groupName === channelsGroup) {
          groupChannels = group.channels;
        }
      })
    }


    if (groupChannels?.length > 0) {

      arrData = groupChannels?.map((header, index) =>
        availableChannels.find((label) => header === label.label)
      );

      const newChannelsValues = [];


      arrData.forEach((data) =>
        newChannelsValues.push({
          label: data.label,
          data: data.data,
          backgroundColor: getRandomColor(),
        })
      )

      channelsLastValues = [...newChannelsValues];

    }


    if (chartChannel?.length > 0) {
      arrData = chartChannel.map((header, index) =>
        availableChannels.find((label) => header === label.label)
      );

      const newChannelsValues = [];



      arrData.forEach((data) =>
        newChannelsValues.push({
          label: data.label,
          data: data.data,
          backgroundColor: getRandomColor(),
        })
      )


      channelsLastValues = [...newChannelsValues];
    };

    const convertedTimeArr = Array.isArray(filteredTimeArr) && filteredTimeArr.length > 0 ? filteredTimeArr.map((label) => new Date(label)) : timeArr.map((label) => new Date(label));


    const convertedTimeArrLength = convertedTimeArr.length
    const filteredMatchData = channelsLastValues.map((dataset) => {
      return {
        ...dataset,
        data: Array.isArray(dataset?.data)
          ? dataset?.data?.slice(-convertedTimeArrLength)
          : []
      }
    })

    const datasets = filteredMatchData.map(ds => {
      const color = getRandomColor();
      return {
        label: ds.label,
        data: ds.data,
        backgroundColor: color,

      };
    });


    const newChartData = {
      labels: filteredTimeArr.length ? filteredTimeArr : timeArr,
      datasets,
    };

    const options = {
      scales: {
        x: {
          type: "time",
        },
        y: {
          beginAtZero: true,
        },
      },
      animation: false,
      plugins: {
        decimation: {
          enabled: true,
          algorithm: "lttb",
          threshold: 200,
        },
        zoom: {
          pan: {
            enabled: true,
            mode: "y",
            modifierKey: "ctrl",
          },
          zoom: {
            wheel: {
              enabled: true,
            },
            pinch: {
              enabled: true,
            },

            mode: "y",
          },
        },
        legend: {
          align: "left", // Set the alignment to 'left'
          labels: {
            boxWidth: 5, // Adjust the width of the legend color box
            font: {
              size: 10, // Set the font size
            },
          },
        },
      },
    };
    setChartOptions(options);
    setNewChartData(newChartData);
  }, [dateTimesLive, selectedTabIndex, chartChannel, endHours, endMinutes, channelsGroup]);

  return (
    <div>
      {newChartData && newChartData.labels ? (
        <Bar data={newChartData} options={chartOptions} />
      ) : (
        <p>Loading chart data...</p>
      )}
    </div>
  );
};

export { Histogram, NewHistogram };